import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ee87f5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Due Date:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_9 = {
  key: 0,
  class: "overdue-note"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Remaining Due:", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Amount Originally Billed:", -1))
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.accountInfo !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading billing info..."))
          : _createCommentVNode("", true),
        (_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Failed to load billing info"))
          : _createCommentVNode("", true),
        (_ctx.invoiceInfo !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.invoiceInfo.invoiceCount !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Invoices:"))
                : _createCommentVNode("", true),
              (_ctx.invoiceInfo.invoiceCount === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " There are no active invoices on this account "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceInfo.invoices, (invoice) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: invoice.id,
                  class: "invoice-section"
                }, [
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.getDueDate(invoice)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(invoice.status) + " ", 1),
                    (_ctx.isOverdue(invoice))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(OVERDUE)"))
                      : _createCommentVNode("", true)
                  ]),
                  (invoice.status !== 'Paid')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(" $" + _toDisplayString(invoice.amountDue), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (invoice.status === 'Paid')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(" $" + _toDisplayString(invoice.amountOriginallyBilled), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: _ctx.getLink(invoice),
                      target: "_blank"
                    }, "VIEW", 8, _hoisted_14)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}